import {
    RECEIVE_GLOBALISATION,
    REQUEST_GLOBALISATION

} from '../../constants/action_types';

export const initialLocaleState = {
    globalisation: []
}

export const localeReducer = (state = initialLocaleState, action = null) => {
    switch (action.type) {

        case RECEIVE_GLOBALISATION:
            return {
                ...state,
                globalisation: action.result
            };

        case REQUEST_GLOBALISATION:
            return {
                ...state,
                data: -1
            };

        default:
            return state;
    }
};
